export default __webpack_public_path__ + "static/media/GW.182761f6.svg";